import { IMAGE_URL_v4 } from "../../envs/prod/constants";
import Learners from "../../components/Icons/LandingPage/Metrics/Learners";
import Mentors from "../../components/Icons/LandingPage/Metrics/Mentors";
import Videos from "../../components/Icons/LandingPage/Metrics/Videos";

const metricsData = [
  {
    icon: <Learners />,
    text: "40 Lakhs",
    subText: "Learners",
  },

  {
    icon: <Videos />,
    text: "10,000+",
    subText: "Videos",
  },

  {
    icon: <Mentors />,
    text: "250+",
    subText: "Mentors",
  },
];

const usersLove = [
  {
    id: 1,
    desc: "Seekho se mujhe Rs 8000 ka fayda hua hai, jo meine Share market ki series se seekha.",
    name: "Dr. Baijnath Jaiswal",
    occupation: "Gorakhpur",
    image: `/assets/usersLove/baijnath.webp`,
    ratings: 5,
  },
  {
    id: 2,
    desc: "Seekho se investing seekh ke 30% ka profit kamaya hai.",
    name: "Sandeep Kumar",
    occupation: "Haryana",
    image: `/assets/usersLove/sandeep.webp`,
    ratings: 5,
  },
  {
    id: 3,
    desc: "YouTube pe sab kuch hai, par Seekho me sab to-the-point hai",
    name: "Neeraj",
    occupation: "Bihar",
    image: `/assets/usersLove/neeraj.webp`,
    ratings: 5,
  },
  {
    id: 4,
    desc: "Seekho se maine video editing seekha. Aaj jo kuch bhi hu Seekho ki wajah se hu.",
    name: "Shivam",
    occupation: "Delhi",
    image: `/assets/usersLove/shivam.webp`,
    ratings: 5,
  },
  {
    id: 5,
    desc: "Seekho par Time waste nahi hota. Yaha hoti hai Seedhi baat no bakwaas.",
    name: "Md. Valiuddin",
    occupation: "UP",
    image: `/assets/usersLove/valiuddin.webp`,
    ratings: 5,
  },
];

const unlockSeekhoPlusData = [
  {
    image: `/assets/landing/UnlockSeekhoPlus/TwentyPlus.webp`,
    text: "Unlimited Videos",
  },
  {
    image: `/assets/landing/UnlockSeekhoPlus/NewVideo.webp`,
    text: "Daily New Videos",
  },
  {
    image: `/assets/landing/UnlockSeekhoPlus/NoAds.webp`,
    text: "Ad-Free Experience",
  },
];

const creatorData = [
  {
    id: 1,
    name: "Shahnawaz Alam",
    image: `${IMAGE_URL_v4}/creators/8.webp`,
    category: "Online Earning Guru",
    stats: { nVideos: 556, views: "4.5M" },
    themeColor: { border: "#1e7a06", bg: "#173d0d" },
  },
  {
    id: 2,
    name: "Bilal Khan",
    image: `/assets/landing/seekhoGurus/BilalKhan.webp`,
    category: "Sarkaari Kaam Guru",
    stats: { nVideos: 237, views: "3M" },
    themeColor: { border: "#310fb8", bg: "#160752" },
  },
  {
    id: 3,
    name: "Sartaz Ahmad",
    image: `/assets/landing/seekhoGurus/Sartaz.webp`,
    category: "English Speaking Guru",
    stats: { nVideos: 344, views: "2M" },
    themeColor: { border: "#b466ab", bg: "#52074b" },
  },
  {
    id: 4,
    name: "Techy Professor",
    image: `/assets/landing/seekhoGurus/TechyProfesor.webp`,
    category: "YouTube AI Guru",
    stats: { nVideos: 529, views: "1.1M" },
    themeColor: { border: "#10aeb8", bg: "#1d5a5f" },
  },

  {
    id: 5,
    name: "Vikash Tiwary",
    image: `/assets/landing/seekhoGurus/VikashTiwary.webp`,
    category: "Share Market Guru",
    stats: { nVideos: 317, views: "992K" },
    themeColor: { border: "#b51415", bg: "#520706" },
  },
  {
    id: 6,
    name: "Kartik Dhiman",
    image: `/assets/landing/seekhoGurus/KartikDhiman.webp`,
    category: "Business Guru",
    stats: { nVideos: 97, views: "621K" },
    themeColor: { border: "#b466ab", bg: "#52074b" },
  },
  {
    id: 7,
    name: "Rahul Jadhav",
    image: `/assets/landing/seekhoGurus/RahulJadhav.webp`,
    category: "Share Market Guru",
    stats: { nVideos: 120, views: "357K" },
    themeColor: { border: "#310fb8", bg: "#160752" },
  },
  {
    id: 8,
    name: "Ripu Daman Handa",
    image: `/assets/landing/seekhoGurus/Ripu.webp`,
    category: "Culinary Guru",
    stats: { nVideos: 127, views: "329K" },
    themeColor: { border: "#b51415", bg: "#520706" },
  },
];

const displayTop15Category = [
  {
    title: "Sarkari Kaam",
    slug: "sarkari-kaam",
  },
  {
    title: "Instagram",
    slug: "instagram",
  },
  {
    title: "Business",
    slug: "business",
  },
  {
    title: "English Speaking",
    slug: "english-speaking",
  },
  {
    title: "Youtube",
    slug: "youtube",
  },
  {
    title: "Part Time Income",
    slug: "online-earning",
  },
  {
    title: "Astrology",
    slug: "astrology",
  },
  {
    title: "Career & Jobs",
    slug: "jobs-career",
  },
  {
    title: "Share Market",
    slug: "invest-money",
  },
  {
    title: "Finance",
    slug: "finance",
  },
  {
    title: "Facebook",
    slug: "facebook",
  },
  {
    title: "Life Hacks",
    slug: "lifestyle",
  },
  {
    title: "Gaming",
    slug: "fantasy",
  },
  {
    title: "Wellness",
    slug: "meditation",
  },
];

const moreReasonsToJoin = [
  {
    title: "Learn From 50+ Categories",
    image: "/assets/landing/ReasonToJoin/fifty-category.webp",
    bgFrom: "#330233",
    bgTo: "#14001400",
  },
  {
    title: "Verified & Trusted Mentors",
    image: "/assets/landing/ReasonToJoin/verified-creators.webp",
    bgFrom: "#011F1F",
    bgTo: "#000A0A00",
  },
  {
    title: "New Videos Everyday",
    image: "/assets/landing/ReasonToJoin/new-videos.webp",
    bgFrom: "#060229",
    bgTo: "#03011400",
  },
  {
    title: "No Ads Experience",
    image: "/assets/landing/ReasonToJoin/no-ads.webp",
    bgFrom: "#290203",
    bgTo: "#29020300",
  },
];

export {
  metricsData,
  usersLove,
  unlockSeekhoPlusData,
  creatorData,
  displayTop15Category,
  moreReasonsToJoin,
};
